import { BookmarkSimpleIcon as PhosphorBookmarkSimpleIcon } from "@phosphor-icons/react/dist/ssr/BookmarkSimple";

import { createAppIcon } from "@/components/createAppIcon";

export const BookmarkIcon = /* @__PURE__ */ createAppIcon(PhosphorBookmarkSimpleIcon);
